export enum QueryKey {
  getListCohorts = 'getListCohorts',
  getListOffers = 'getListOffers',
  getListProducts = 'getListProducts',
  putOffer = 'putOffer',
  postOffer = 'postOffer',
  getOffer = 'getOffer',
  getProduct = 'getProduct',
}
